import React from 'react';
import { Input, InputNumber, Tooltip } from 'antd';

import './styles.scss';
import { cloneObjectWithKey } from '../../utils';

const SettingForm = (props) => {
  const { isblock = false, className = '', textTitle = '', title, useInputNumber } = props;
  const inputProps = cloneObjectWithKey(
    props,
    Object.keys(props).filter((k) => !['textTitle', 'useInputNumber'].includes(k)),
  );
  return (
    <Tooltip title={title}>
      <div className="mo__size-form" style={isblock ? { display: 'block' } : { display: 'flex' }}>
        {useInputNumber ? (
          <InputNumber
            className={className.trim() !== '' ? `${className} input` : 'input'}
            addonBefore={`${textTitle.toUpperCase()}`}
            onSelect={(e) => {
              e.stopPropagation();
            }}
            {...inputProps}
          />
        ) : (
          <Input
            className={className.trim() !== '' ? `${className} input` : 'input'}
            addonBefore={`${textTitle.toUpperCase()}`}
            onSelect={(e) => {
              e.stopPropagation();
            }}
            {...inputProps}
          />
        )}
      </div>
    </Tooltip>
  );
};

export default SettingForm;
